import React from "react";

import { useHistory, useParams } from "react-router-dom";

import ROUTES from "manager/config/routes";
import PasswordRecoverySetPasswordPage from "shared/pages/PasswordRecoverySetPasswordPage";

import { ParamsProps } from "./interfaces";

const PasswordRecoverySetPasswordContainer = () => {
  const history = useHistory();

  const { token }: ParamsProps = useParams();

  const onSuccess = () => window.location.href = ROUTES.selectCompany;

  return (
    <PasswordRecoverySetPasswordPage onSuccessLogin={onSuccess} token={token} />
  );
};

export default PasswordRecoverySetPasswordContainer;
